<template>
    <v-container fill-height>
        <v-alert
            class="mx-auto px-12"
            border="right"
            colored-border
            elevation="1"
        >
            <v-row>
                <v-icon left>error</v-icon>
                <div class="text-h6 py-4">Page not found.</div>
            </v-row>
            <p v-if="$route.path != '/notfound'" class="text-subtitle-2">path : {{ $route.path }}</p>

            <v-divider class="my-4"></v-divider>

            <v-row align="center" class="py-3">
                <v-col class="grow py-0"
                    >Some part of our website are in development.</v-col
                >
                <v-col class="shrink py-0">
                    <v-row style="flex-wrap: nowrap">
                        <v-btn text color="primary" @click="back()">Back</v-btn>
                        <v-btn text color="primary" to="/">Home</v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </v-alert>
    </v-container>
</template>

<script>
export default {
    methods: {
        back() {
            // '/animals/fish'.replace(..) -> '/animals/'
            let path = this.$route.path.replace(/\w+\/*$/, "");
            this.$router.push(path);
        },
    },
    metaInfo() {
        return {
            title: "Page not found",
            titleTemplate: "%s · Marketpett",
            meta: [{ name: "robots", content: "noindex" }],
        };
    },
};
</script>

<style>
</style>